import { getURL } from '@/service/http';

export const uploadFileToStorage = async (formFiles, options) => {
  // адрес API метода загрузки
  const url = getURL('upload');

  // загрузка файлов в хранилище производится
  // при помощи стандартного класса FormData
  const formData = new FormData();
  for (let i = 0; i < formFiles.length; i++) {
    formData.append('content', formFiles[i]);
    formData.append('info', JSON.stringify({ dt: new Date(formFiles[i].lastModified).toISOString() }));
  }

  const headers = new Headers();
  // установка заголовков, которые будут сохранены
  // в мета-информации у загруженного файла
  // Все заголовки, начинающиеся с префикса "X-ASUSE-",
  // будут сохранены вместе с файлом
  for (const [key, value] of Object.entries(options)) {
    headers.append(`X-ASUSE-${key}`, encodeURI(value));
  }

  // используется POST метод
  const fetchOptions = {
    method: 'post',
    headers,
    body: formData,
  };

  // само обращение к методу
  try {
    const answer = await fetch(url, fetchOptions);
    return (await answer.json());
  } catch (error) {
    console.error('Error:', error);
  }
};
